<script>
import TextContent from '@/components/TextContent.vue';

export default {
  name: 'BlackWhiteFilters',
  components: { TextContent },
  props: ['caption', 'whitelist', 'blacklist'],
  data() {
    return {
      whitelistData: [],
      blacklistData: [],
    };
  },
  methods: {
    filterList(list) {
      return list.filter(v => v.length > 0);
    },
  },
  watch: {
    whitelist: {
      handler(val) {
        this.whitelistData = val;
      },
    },
    blacklist: {
      handler(val) {
        this.blacklistData = val;
      },
    },
    whitelistData: {
      handler(val) {
        this.$emit('update:whitelist', val);
      },
    },
    blacklistData: {
      handler(val) {
        this.$emit('update:blacklist', val);
      },
    },
  },
};
</script>

<template>
  <div>
    <div class="create-feed-form--textarea-heading mb-10">{{ caption }}</div>
    <div class="create-feed-form--textarea-row mb-10">
      <div class="input-block">
        <div class="input-block--text">Whitelist ({{ filterList(whitelistData).length }}):</div>
        <text-content v-model="whitelistData" :transform="(v) => v.toUpperCase()" />
      </div>
      <div class="input-block">
        <div class="input-block--text">Blacklist ({{ filterList(blacklistData).length }}):</div>
        <text-content v-model="blacklistData" :transform="(v) => v.toUpperCase()" />
      </div>
    </div>
  </div>
</template>
